import { render, staticRenderFns } from "./officialMember.vue?vue&type=template&id=b7ddc9b8"
import script from "./officialMember.vue?vue&type=script&lang=js"
export * from "./officialMember.vue?vue&type=script&lang=js"
import style0 from "./officialMember.vue?vue&type=style&index=0&id=b7ddc9b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports